const data = {
  "languageSwitcher": {
    "dropdown": {
      "fact": "Language",
      "slogan": "Ik bedoel taal."
    }
  }
};

export default data;